import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import {
  Panel,
  Modal,
  Row,
  Col,
  Uploader,
  Icon,
  Table,
  ButtonGroup,
  IconButton,
  Input,
  Button,
  Message,
  ControlLabel,
  SelectPicker,
} from 'rsuite'
import { isRequired, isValidators, isImageOrPdf } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import CustomIconMessageInfo from '../../widgets/CustomIconMessageInfo'
import classNames from 'classnames'

export default function AttachFilesMakeContract({
  schema,
  // register,
  // errors,
  // Controller,
  // control,
  // setValue,
  // clearErrors,
  onSubmit,
  onUpdate,
  onDelete,
  onPreview,
  onDownload,
  onPrepareUploadFile = () => {},
  ...props
}) {
  const { isEditErr, isUploadErr, isDeleteError, loading } = props
  const { Column, HeaderCell, Cell } = Table
  const [fileList, setFileList] = useState([])
  const [attachFiles, setAttachFiles] = useState([])
  const [selectEditeIndex, setSelectEditeIndex] = useState(-1)
  const [editName, setEditName] = useState()
  const [deleteIndex, setDeleteIndex] = useState()
  const [isAdd, setIsAdd] = useState(false)
  const [isDeleteFail, setIsDeleteFail] = useState(false)
  const [isUploadError, setIsUploadError] = useState(false)
  const [isEditError, setIsEditError] = useState(false)
  const [isdelete, setIsdelete] = useState(false)
  const [deleteId, setDeleteId] = useState()
  const [fileTypeError, setFileTypeError] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()

  useEffect(() => {
    console.log('AttachFilesForm schema', schema.attachFiles)
    setAttachFiles([...(schema.attachFiles.value || [])])
    if (!isEditErr) {
      setEditName()
      setSelectEditeIndex(-1)
    }
  }, [schema.attachFiles])

  useEffect(() => {
    setIsDeleteFail(isDeleteError)
  }, [isDeleteError])
  useEffect(() => {
    if (!isEditErr) {
      console.log('isEditErr', isEditErr)
    }
    setIsEditError(isEditErr)
  }, [isEditErr])
  useEffect(() => {
    setIsUploadError(isUploadErr)
    setIsAdd(isUploadErr)
  }, [isUploadErr])

  const onAdd = () => {
    setIsAdd(true)
    setFileList([])
  }

  const onAddFile = (file) => {
    setFileList(file)
    setValue(schema.attachFiles.name, file)
  }

  const handleDeleteFile = (rowData, index) => {
    setDeleteIndex(index)
    setDeleteId(rowData.id)
    setIsdelete(true)
  }

  const handleEditFile = (rowData, index) => {
    setEditName(rowData.label)
    setSelectEditeIndex(index)
  }

  const validateEditFileName = (rowData, index) => {
    if (selectEditeIndex == index) {
      return (
        <Row>
          {isEditError && (
            <Col style={{ marginBottom: 10 }}>
              <Message showIcon type="error" description={`แก้ไขไม่สำเร็จ`} />
            </Col>
          )}
          <Col xs={19} sm={19} md={19} lg={19}>
            <Input value={editName} onChange={(value) => setEditName(value)} />
          </Col>
          <Col xs={5} sm={5} md={5} lg={5}>
            <ButtonGroup>
              <IconButton
                appearance="ghost"
                icon={<Icon icon="check" className="bt-gost-icon-radius" />}
                onClick={(e) => {
                  onUpdate(rowData, editName)
                }}
              />
              <IconButton
                appearance="ghost"
                className="rs-btn-ghost-cancel"
                icon={<Icon icon="close" className="bt-gost-icon-none-radius-cancel" />}
                onClick={(e) => {
                  setEditName('')
                  setIsEditError(false)
                  setSelectEditeIndex(-1)
                }}
              />
            </ButtonGroup>
          </Col>
        </Row>
      )
    } else {
      return rowData.label
    }
  }

  return (
    <>
      {/* <Panel header={schema.attachFiles.buttonText} eventKey={2} shaded style={{ marginBottom: '2em' }}> */}
      {schema.attachFiles.description && (
        <Row style={{ marginTop: 10 }}>
          <CustomIconMessageInfo contents={schema.attachFiles.description} />
        </Row>
      )}

      {!isAdd && (
        <Row style={{ marginTop: 10 }}>
          <div>
            <IconButton
              appearance="ghost"
              icon={<Icon appearance="ghost" icon="plus" className="bt-gost-icon-radius" />}
              onClick={onAdd}
              style={{ marginRight: 5 }}
            >
              {`เพิ่ม${schema.attachFiles.buttonText ? schema.attachFiles.buttonText : ''}`}
            </IconButton>
          </div>
        </Row>
      )}
      {isAdd && (
        <>
          <Row style={{ marginTop: 10 }}>
            <ErrorMessage error={errors[schema.attachFiles.name]} />
          </Row>

          <Controller
            key={schema.attachFiles.name}
            name={schema.attachFiles.name}
            control={control}
            rules={isValidators(schema.attachFiles.validators)}
            defaultValue={fileList}
          />
          <Row style={{ marginTop: 10 }}>
            <p>แนบไฟล์</p>
            {fileTypeError && (
              <Message
                style={{ marginTop: 10, marginBottom: 10 }}
                closable
                onClose={() => {
                  setFileTypeError(false)
                }}
                showIcon
                type="error"
                description="อัพโหลดไฟล์เป็นรูปภาพหรือ PDF เท่านั้น *** ชนิดที่รองรับ png , jpeg , jpg , pdf ***"
              />
            )}
            <Uploader
              // fileListVisible={false}
              autoUpload={false}
              fileList={props.value}
              listType="picture-text"
              onChange={(files) => {
                let file = files[files.length - 1]
                if (!file || isImageOrPdf(file.blobFile.type)) {
                  onAddFile(files)
                  setFileTypeError(false)
                } else {
                  files.splice(files.length - 1, 1)
                  onAddFile(fileList)
                  setFileTypeError(true)
                }

                if (file) {
                  onPrepareUploadFile(true)
                } else {
                  onPrepareUploadFile(false)
                }
              }}
              onRemove={(file) => {
                console.log(file)
                onPrepareUploadFile(false)
              }}
              draggable
            >
              <div style={{ lineHeight: '100px' }}>
                <Icon size="4x" icon="upload2" />
                <small
                  style={{
                    marginTop: '-70px',
                    display: 'block',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }}
                >
                  คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                </small>
              </div>
            </Uploader>
          </Row>

          <Row>
            <ControlLabel
              className={classNames(
                'style-text-lable',
                isRequired(schema.contractFileType.validators) && 'required'
              )}
            >
              {schema.contractFileType.label}
            </ControlLabel>
            <ErrorMessage error={errors.contractFileType} />
            <Controller
              name={schema.contractFileType.name}
              control={control}
              defaultValue={schema.contractFileType.value}
              rules={isValidators(schema.contractFileType.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={schema.contractFileType.options}
                    value={props.value}
                    style={{ marginTop: '3px', width: '100%' }}
                    searchable={false}
                    placeholder="เลือก"
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Row>

          {isUploadError && (
            <Row style={{ marginTop: 10 }}>
              <Message
                showIcon
                type="error"
                description={`อัพโหลด${
                  schema.attachFiles.buttonText ? schema.attachFiles.buttonText : ''
                }ไม่สำเร็จ`}
              />
            </Row>
          )}

          <Row style={{ marginTop: 10 }}>
            <IconButton
              appearance="ghost"
              icon={<Icon appearance="ghost" icon="upload2" className="bt-gost-icon-radius" />}
              onClick={handleSubmit(onSubmit)}
              style={{ marginRight: 5 }}
              disabled={loading || fileList?.length < 1}
            >
              {`อัพโหลด${schema.attachFiles.buttonText ? schema.attachFiles.buttonText : ''}`}
            </IconButton>
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-cancel"
              icon={
                <Icon appearance="ghost" icon={'close'} className="bt-gost-icon-radius-cancel" />
              }
              onClick={(e) => {
                setIsAdd(false)
                setIsDeleteFail(false)
                setFileTypeError(false)
                onPrepareUploadFile(false)
              }}
              style={{ marginRight: 5 }}
              disabled={loading}
            >
              {`ยกเลิก${schema.attachFiles.buttonText ? schema.attachFiles.buttonText : ''}`}
            </IconButton>
          </Row>
        </>
      )}
      <Row style={{ marginTop: 10 }}>
        {isDeleteFail && (
          <Row style={{ marginTop: 10 }}>
            <Message showIcon type="error" description={`ลบไฟล์ไม่สำเร็จ`} />
          </Row>
        )}
        <Table height={300} wordWrap bordered data={attachFiles}>
          <Column width={90} align="center" fixed>
            <HeaderCell>ไฟล์ที่</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>
          <Column minWidth={300} flexGrow={1}>
            <HeaderCell>ชื่อไฟล์</HeaderCell>
            {/* <Cell dataKey="name" /> */}
            <Cell>
              {(rowData, index) => {
                return validateEditFileName(rowData, index)
              }}
            </Cell>
          </Column>

          <Column minWidth={100} flexGrow={1}>
            <HeaderCell>ประเภทไฟล์</HeaderCell>
            <Cell dataKey="contractFileType" />
          </Column>

          <Column width={200} align="center">
            <HeaderCell></HeaderCell>
            <Cell>
              {(rowData, index) => {
                return (
                  <ButtonGroup>
                    <IconButton
                      appearance="ghost"
                      icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                      onClick={(e) => onPreview(rowData)}
                      disabled={loading}
                    />
                    <IconButton
                      appearance="ghost"
                      icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                      onClick={(e) => onDownload(rowData)}
                      disabled={loading}
                    />

                    {/* <IconButton
                      appearance="ghost"
                      className="rs-btn-ghost-edit"
                      disabled={loading || selectEditeIndex == index}
                      icon={<Icon icon="pencil" className="bt-gost-icon-none-radius-edit" />}
                      onClick={(e) => handleEditFile(rowData, index)}
                    /> */}
                    <IconButton
                      appearance="ghost"
                      className="rs-btn-ghost-cancel"
                      icon={<Icon icon="trash-o" className="bt-gost-icon-none-radius-cancel" />}
                      onClick={(e) => handleDeleteFile(rowData, index)}
                      disabled={!rowData.enableDelete}
                    />
                  </ButtonGroup>
                )
              }}
            </Cell>
          </Column>
        </Table>
      </Row>
      {/* </Panel> */}

      <Modal
        show={isdelete}
        onHide={(e) => {
          setIsdelete(false)
        }}
      >
        <Modal.Header>
          <Modal.Title>ยืนยันการลบ</Modal.Title>
        </Modal.Header>
        <Modal.Body>{'ยืนยันการลบไฟล์'}</Modal.Body>
        <Modal.Footer>
          <Button
            onClick={(e) => {
              onDelete(deleteId)
              setIsdelete(false)
            }}
            appearance="primary"
          >
            ลบ
          </Button>
          <Button
            onClick={(e) => {
              setIsdelete(false)
              setDeleteIndex('')
              setDeleteId('')
            }}
            appearance="subtle"
          >
            ยกเลิก
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
